import {
  IAdapterData,
  ICountryAdapterData,
  ICountryAdapterPatchRequest,
  ICountryAdapterResponse,
} from "@/entities";
import { BACKEND_BASE_URL, IResponseError } from "@/services";
import { handleResponse } from "@/services/handlers";
import Vue from "vue";
import { IAdapterService } from "./adapter.types";

export class AdapterService implements IAdapterService {
  async getAssignableAdapters(): Promise<IAdapterData[] | undefined> {
    const { response, error } = await handleResponse<IAdapterData[], IResponseError>(
      Vue.$axios.get(`${BACKEND_BASE_URL}/api/configuration/v1/adapter/assignable`)
    );
    if (error) {
      return undefined;
    } else {
      return response?.data;
    }
  }

  async getCountryAdaptersByCountryCodeAndNonAssignable(
    countryCode: string
  ): Promise<ICountryAdapterData[] | undefined> {
    const { response, error } = await handleResponse<ICountryAdapterResponse, IResponseError>(
      Vue.$axios.get(
        `${BACKEND_BASE_URL}/api/configuration/v1/country_adapter/${countryCode}/non-assignable`
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.data.countryAdapters;
    }
  }

  async patchCountryAdaptersByCountryCodeAndNonAssignable(
    countryCode: string,
    payload: ICountryAdapterPatchRequest
  ): Promise<boolean | undefined> {
    const { response, error } = await handleResponse<undefined, IResponseError>(
      Vue.$axios.patch(
        `${BACKEND_BASE_URL}/api/configuration/v1/country_adapter/${countryCode}/non-assignable`,
        payload
      )
    );
    if (error) {
      return undefined;
    } else {
      return response?.status === 200 || response?.status === 204;
    }
  }
}
